import { PageModule, LanguagesAbbr } from "../types/working-model";

// Get Language or base of translated string or .html for old untranslated string
export function getBlankModuleHtml(module: PageModule | null | undefined, language: LanguagesAbbr): string {
	if (!module) { return ''; }
	const content = module?.content;

	return content?.translated_html?.[language] ?? content?.translated_html?.base ?? content?.html ?? '';
}
